/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Plain_Text_Import_Preview_More_BlocksInputs */

const en_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} more blocks not shown)`)
};

const fr_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} blocs supplementaires non affiches)`)
};

const de_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} weitere Blöcke nicht angezeigt)`)
};

const it_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (altri ${i?.count} blocchi non mostrati)`)
};

const ru_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} другие блоки не показаны)`)
};

const es_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} bloques más no mostrados)`)
};

const zh_cn2_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`（${i?.count} 更多区块未显示）`)
};

const ja_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} 以上のブロックは表示されません)`)
};

const hi_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} और ब्लॉक नहीं दिखाए गए)`)
};

const pt_pt2_plain_text_import_preview_more_blocks = /** @type {(inputs: Plain_Text_Import_Preview_More_BlocksInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`... (${i?.count} mais blocos não mostrados)`)
};

/**
* | output |
* | --- |
* | "... ({count} more blocks not shown)" |
*
* @param {Plain_Text_Import_Preview_More_BlocksInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const plain_text_import_preview_more_blocks = /** @type {((inputs: Plain_Text_Import_Preview_More_BlocksInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plain_Text_Import_Preview_More_BlocksInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_plain_text_import_preview_more_blocks(inputs)
	if (locale === "de") return de_plain_text_import_preview_more_blocks(inputs)
	if (locale === "it") return it_plain_text_import_preview_more_blocks(inputs)
	if (locale === "ru") return ru_plain_text_import_preview_more_blocks(inputs)
	if (locale === "es") return es_plain_text_import_preview_more_blocks(inputs)
	if (locale === "zh-CN") return zh_cn2_plain_text_import_preview_more_blocks(inputs)
	if (locale === "ja") return ja_plain_text_import_preview_more_blocks(inputs)
	if (locale === "hi") return hi_plain_text_import_preview_more_blocks(inputs)
	if (locale === "pt-PT") return pt_pt2_plain_text_import_preview_more_blocks(inputs)
	return en_plain_text_import_preview_more_blocks(inputs)
});